<main>
  <lib-header
    [title]="headerTitle()"
    [iconPath]="headerLogoService.logoSrc()"
    [iconRoute]="'/'"
    [headlineRoute]="'/'"
    [backgroundColor]="headerColorService.color()"
    [showInboxIcon]="isLoggedIn()"
    [unreadCount]="inboxBadge.unreadCount()"
    [inboxRoute]="'/postfach'"
  >
    <app-user-menu [profile]="profile()" [memberships]="memberships()" />
  </lib-header>
  <app-server-unavailable-banner></app-server-unavailable-banner>
  <app-breadcrumb></app-breadcrumb>
  <div class="app">
    <router-outlet></router-outlet>
  </div>
</main>
